import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Strings } from "src/modules/utils/shared/strings";

@Pipe({
    name: 'keepHtml', pure: false,
    standalone: false
})
export class KeepHtmlPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(content: any): SafeResourceUrl {
        return Strings.is(content) ? this.sanitizer.bypassSecurityTrustHtml(content as string) : null;
    }
}